import { type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

type Props = {
  children: ReactNode
  requireRole?: string
}

export function ProtectedRoute({ children, requireRole }: Props) {
  const token = useAuthStore((s) => s.token)
  const user = useAuthStore((s) => s.user)
  const status = useAuthStore((s) => s.status)
  const location = useLocation()

  if (status === 'hydrating') {
    return (
      <div className="flex h-screen items-center justify-center text-mute">
        Authenticating…
      </div>
    )
  }

  if (!token) {
    // Preserve the full URL (pathname + search + hash) so that deep links
    // from transactional emails — e.g. /purchase-orders?po=%23123&action=approve —
    // resume correctly after the user signs in. Login reads `from` as a string
    // and passes it directly to navigate().
    const fullPath = `${location.pathname}${location.search}${location.hash}`
    return <Navigate to="/login" replace state={{ from: fullPath }} />
  }

  if (requireRole && user?.role !== requireRole) {
    return <Navigate to="/purchase-orders" replace />
  }

  return <>{children}</>
}
